const ErrorMessages = {
  CONVERSATION_NOT_FOUND: 'CONVERSATION_NOT_FOUND',
}

export default ErrorMessages
